// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/area_estimation.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreditSource } from "./credit_pb";
import { file_api_proto_v1_credit } from "./credit_pb";
import type { Upload } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/area_estimation.proto.
 */
export const file_api_proto_v1_area_estimation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_credit, file_api_proto_v1_file, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * 図面ページ座標 (px) の 2D 点。
 *
 * @generated from message api_proto.v1.ElevationPoint
 */
export type ElevationPoint = Message<"api_proto.v1.ElevationPoint"> & {
  /**
   * @generated from field: double x = 1;
   */
  x: number;

  /**
   * @generated from field: double y = 2;
   */
  y: number;
};

/**
 * Describes the message api_proto.v1.ElevationPoint.
 * Use `create(ElevationPointSchema)` to create a new message.
 */
export const ElevationPointSchema: GenMessage<ElevationPoint> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 0);

/**
 * 画像サイズ (px)。
 *
 * @generated from message api_proto.v1.ElevationImageSize
 */
export type ElevationImageSize = Message<"api_proto.v1.ElevationImageSize"> & {
  /**
   * @generated from field: int32 width = 1;
   */
  width: number;

  /**
   * @generated from field: int32 height = 2;
   */
  height: number;
};

/**
 * Describes the message api_proto.v1.ElevationImageSize.
 * Use `create(ElevationImageSizeSchema)` to create a new message.
 */
export const ElevationImageSizeSchema: GenMessage<ElevationImageSize> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 1);

/**
 * ポリゴンの 1 リング。
 *
 * @generated from message api_proto.v1.ElevationRing
 */
export type ElevationRing = Message<"api_proto.v1.ElevationRing"> & {
  /**
   * ポリゴン内で一意
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: api_proto.v1.ElevationRingRole role = 2;
   */
  role: ElevationRingRole;

  /**
   * 図面ページ px 座標。3 点以上。閉じた輪郭 (末尾に先頭を重複させない)
   *
   * @generated from field: repeated api_proto.v1.ElevationPoint points = 3;
   */
  points: ElevationPoint[];

  /**
   * 内周の種類 (参照実装 rings[].kind)。opening = 開口として控除する穴 / ownership_cutout = 共通割当で
   * 他の面や開口部に取られた切り抜き (開口として数えない)。空は opening と同じ (旧データ)。外周では空
   *
   * @generated from field: string kind = 4;
   */
  kind: string;
};

/**
 * Describes the message api_proto.v1.ElevationRing.
 * Use `create(ElevationRingSchema)` to create a new message.
 */
export const ElevationRingSchema: GenMessage<ElevationRing> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 2);

/**
 * リング検査の 1 指摘 (polygon_validation の error/warning)。
 *
 * @generated from message api_proto.v1.ElevationValidationIssue
 */
export type ElevationValidationIssue = Message<"api_proto.v1.ElevationValidationIssue"> & {
  /**
   * 例: outer_self_intersection / inner_outside_outer / non_positive_net_area
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * 対象リング。無ければ空
   *
   * @generated from field: string ring_id = 2;
   */
  ringId: string;
};

/**
 * Describes the message api_proto.v1.ElevationValidationIssue.
 * Use `create(ElevationValidationIssueSchema)` to create a new message.
 */
export const ElevationValidationIssueSchema: GenMessage<ElevationValidationIssue> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 3);

/**
 * リング構造の検査結果 (polygon_validation.validate_polygon_rings と同じ意味論)。
 *
 * @generated from message api_proto.v1.ElevationGeometryValidation
 */
export type ElevationGeometryValidation = Message<"api_proto.v1.ElevationGeometryValidation"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: repeated api_proto.v1.ElevationValidationIssue errors = 2;
   */
  errors: ElevationValidationIssue[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationValidationIssue warnings = 3;
   */
  warnings: ElevationValidationIssue[];

  /**
   * @generated from field: double outer_area_px = 4;
   */
  outerAreaPx: number;

  /**
   * @generated from field: double inner_area_px = 5;
   */
  innerAreaPx: number;

  /**
   * @generated from field: double net_area_px = 6;
   */
  netAreaPx: number;
};

/**
 * Describes the message api_proto.v1.ElevationGeometryValidation.
 * Use `create(ElevationGeometryValidationSchema)` to create a new message.
 */
export const ElevationGeometryValidationSchema: GenMessage<ElevationGeometryValidation> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 4);

/**
 * ポリゴンの証拠・診断 (積算規則 §2.3: AI の回答だけでは確定根拠にならない)。
 *
 * @generated from message api_proto.v1.ElevationEvidence
 */
export type ElevationEvidence = Message<"api_proto.v1.ElevationEvidence"> & {
  /**
   * 例: vision_coordinate_refined_by_source_lines / manual_review / manual_input
   *
   * @generated from field: string decision_source = 1;
   */
  decisionSource: string;

  /**
   * 由来した元線候補面の ID
   *
   * @generated from field: repeated string source_candidate_ids = 2;
   */
  sourceCandidateIds: string[];

  /**
   * 根拠にした元線分 ID
   *
   * @generated from field: repeated string source_edge_ids = 3;
   */
  sourceEdgeIds: string[];

  /**
   * @generated from field: repeated string source_vertex_ids = 4;
   */
  sourceVertexIds: string[];

  /**
   * @generated from field: repeated string dimension_ids = 5;
   */
  dimensionIds: string[];

  /**
   * 0.0〜1.0
   *
   * @generated from field: double ai_confidence = 6;
   */
  aiConfidence: number;

  /**
   * @generated from field: string ai_reason = 7;
   */
  aiReason: string;

  /**
   * 解析時のリング検査結果。**現在は誰も書き込まず、誰も読まない** (#2489)。
   * 検査結果は「解析時点のジオメトリ」に対するもので人が編集した瞬間に陳腐化する一方、
   * 参照箇所がフロント・Go とも 0 件だった。リング検査の SSOT は Go の
   * logic/elevation.ValidatePolygonRings (保存時・計算時に都度実行) 一本に統一している。
   * proto.md の方針に従い即削除はせず deprecated で残す (番号 8 は再利用しない)。
   *
   * @generated from field: api_proto.v1.ElevationGeometryValidation geometry_validation = 8 [deprecated = true];
   * @deprecated
   */
  geometryValidation?: ElevationGeometryValidation;

  /**
   * v3 (参照実装 f03b1c5) でマスクの元線吸着を廃止したため、解析は書き込まない。
   * 番号は再利用しない
   *
   * @generated from field: int32 reference_line_count = 9 [deprecated = true];
   * @deprecated
   */
  referenceLineCount: number;

  /**
   * @generated from field: int32 moved_vertex_count = 10 [deprecated = true];
   * @deprecated
   */
  movedVertexCount: number;

  /**
   * 部位競合の診断
   *
   * @generated from field: repeated string conflicts = 11;
   */
  conflicts: string[];

  /**
   * @generated from field: string notes = 12;
   */
  notes: string;

  /**
   * 元図線から見つけた開口部のうち、このポリゴンに付いたものの候補 ID
   *
   * @generated from field: repeated string source_opening_candidate_ids = 13;
   */
  sourceOpeningCandidateIds: string[];

  /**
   * 元図線から見つけた開口部 (外壁のみ)。解析時点の元図から決まり、利用者は編集しない。
   * 面積の控除には使わず (控除は inner ring で行う)、コーキングの開口周長と
   * バルコニー対面の窓控除の候補に使う
   *
   * @generated from field: repeated api_proto.v1.ElevationSourceOpening source_openings = 14;
   */
  sourceOpenings: ElevationSourceOpening[];

  /**
   * バルコニー上端に接する窓の投影範囲 (バルコニーのみ)。**表示専用**で計算には使わない
   * (計算はその時点の外周・内周から窓控除を求め直す)
   *
   * @generated from field: repeated api_proto.v1.ElevationBalconyWindowProjection balcony_window_projections = 15;
   */
  balconyWindowProjections: ElevationBalconyWindowProjection[];

  /**
   * 元図線による外周補正の結果 (POLYGON_REFINEMENT_MODE)。未実行なら null
   *
   * @generated from field: api_proto.v1.ElevationPolygonRefinement polygon_refinement = 16;
   */
  polygonRefinement?: ElevationPolygonRefinement;
};

/**
 * Describes the message api_proto.v1.ElevationEvidence.
 * Use `create(ElevationEvidenceSchema)` to create a new message.
 */
export const ElevationEvidenceSchema: GenMessage<ElevationEvidence> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 5);

/**
 * 元図線から見つけた開口部 (参照実装 generic_openings / sourceOpenings)。
 *
 * @generated from message api_proto.v1.ElevationSourceOpening
 */
export type ElevationSourceOpening = Message<"api_proto.v1.ElevationSourceOpening"> & {
  /**
   * 同一方位内の重複除去キー
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 閉じた輪郭 (末尾に先頭を重複させない)
   *
   * @generated from field: repeated api_proto.v1.ElevationPoint points = 2;
   */
  points: ElevationPoint[];

  /**
   * 例: source_line
   *
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * @generated from field: string source_candidate_id = 4;
   */
  sourceCandidateId: string;

  /**
   * @generated from field: repeated string source_edge_ids = 5;
   */
  sourceEdgeIds: string[];

  /**
   * 長方形化の採否 (参照実装 opening_rectangularization.accepted)。
   * 面積計算はこれが false の開口を控除に使わず、true かつ外周整理済み
   * (ElevationPolygonRefinement.outline_prepared) のときだけ面の内側の開口も控除する。
   * 未設定 = 長方形化の判定が無い (外周の切り欠きとしてだけ扱う)
   *
   * @generated from field: optional bool rectangularization_accepted = 6;
   */
  rectangularizationAccepted?: boolean;
};

/**
 * Describes the message api_proto.v1.ElevationSourceOpening.
 * Use `create(ElevationSourceOpeningSchema)` to create a new message.
 */
export const ElevationSourceOpeningSchema: GenMessage<ElevationSourceOpening> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 6);

/**
 * バルコニー上端に接する窓の投影範囲 (4 点の矩形)。
 *
 * @generated from message api_proto.v1.ElevationBalconyWindowProjection
 */
export type ElevationBalconyWindowProjection = Message<"api_proto.v1.ElevationBalconyWindowProjection"> & {
  /**
   * @generated from field: repeated api_proto.v1.ElevationPoint points = 1;
   */
  points: ElevationPoint[];

  /**
   * @generated from field: repeated string source_line_ids = 2;
   */
  sourceLineIds: string[];

  /**
   * @generated from field: string source_kind = 3;
   */
  sourceKind: string;

  /**
   * 窓を持つ外壁 (参照実装 wall_instance_id)
   *
   * @generated from field: string wall_polygon_id = 4;
   */
  wallPolygonId: string;
};

/**
 * Describes the message api_proto.v1.ElevationBalconyWindowProjection.
 * Use `create(ElevationBalconyWindowProjectionSchema)` to create a new message.
 */
export const ElevationBalconyWindowProjectionSchema: GenMessage<ElevationBalconyWindowProjection> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 7);

/**
 * 元図線による外周補正の結果 (参照実装 diagnostics.polygon_refinement の要約)。
 *
 * @generated from message api_proto.v1.ElevationPolygonRefinement
 */
export type ElevationPolygonRefinement = Message<"api_proto.v1.ElevationPolygonRefinement"> & {
  /**
   * legacy / shadow / apply / cell_shadow / cell_apply
   *
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * 座標を元図線に差し替えたか
   *
   * @generated from field: bool applied = 3;
   */
  applied: boolean;

  /**
   * @generated from field: repeated string failure_codes = 4;
   */
  failureCodes: string[];

  /**
   * @generated from field: repeated string source_line_ids = 5;
   */
  sourceLineIds: string[];

  /**
   * 外周整理を通したか (参照実装 polygon_refinement.outline_preparation の有無)。
   * 面積計算は、これが真のときだけ面の内側にある元図線由来の開口を控除に使う
   *
   * @generated from field: bool outline_prepared = 6;
   */
  outlinePrepared: boolean;
};

/**
 * Describes the message api_proto.v1.ElevationPolygonRefinement.
 * Use `create(ElevationPolygonRefinementSchema)` to create a new message.
 */
export const ElevationPolygonRefinementSchema: GenMessage<ElevationPolygonRefinement> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 8);

/**
 * 方位図上の 1 ポリゴン (ポリゴン仕様 §2.2)。
 *
 * @generated from message api_proto.v1.ElevationPolygon
 */
export type ElevationPolygon = Message<"api_proto.v1.ElevationPolygon"> & {
  /**
   * 図面内で一意。例 "south_exterior_wall_ai_1"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 同一実面の重複計上防止用 (ポリゴン仕様 §2.3)。未対応付けなら空
   *
   * @generated from field: string surface_id = 2;
   */
  surfaceId: string;

  /**
   * @generated from field: api_proto.v1.ElevationDirection direction = 3;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: api_proto.v1.ElevationPart part = 4;
   */
  part: ElevationPart;

  /**
   * 表示名
   *
   * @generated from field: string label = 5;
   */
  label: string;

  /**
   * outer 1 つ + inner 0..n
   *
   * @generated from field: repeated api_proto.v1.ElevationRing rings = 6;
   */
  rings: ElevationRing[];

  /**
   * 解析時点の参考面積 (m²)。編集後の計算はリングから都度算出する
   *
   * @generated from field: double source_area_m2 = 7;
   */
  sourceAreaM2: number;

  /**
   * @generated from field: api_proto.v1.ElevationReviewStatus review_status = 8;
   */
  reviewStatus: ElevationReviewStatus;

  /**
   * @generated from field: api_proto.v1.ElevationEvidence evidence = 9;
   */
  evidence?: ElevationEvidence;

  /**
   * 利用者が手動追加したポリゴン
   *
   * @generated from field: bool manual = 10;
   */
  manual: boolean;

  /**
   * 計上に含めるか (保存形式 2)。参照実装は旧 review_status=excluded をこの項目へ移行する
   * (geometry_state.migrate_saved_polygon)。未設定の既存データは「含める」として読む
   *
   * @generated from field: optional bool include = 11;
   */
  include?: boolean;

  /**
   * 外周の削減状態と点数 (保存形式 2)。どの面がどれだけ単純化されたかを画面と履歴に残す
   *
   * @generated from field: api_proto.v1.ElevationGeometryState geometry_state = 12;
   */
  geometryState?: ElevationGeometryState;

  /**
   * 共通割当の単位 (参照実装 viewId)。同じ方位名でも別の立面図なら別の単位にする。
   * 空だと方位名で代用するため、同じページに同方位の別立面図があると互いに控除してしまう
   *
   * @generated from field: string view_id = 13;
   */
  viewId: string;

  /**
   * 割当の結果 (参照実装 geometryStatus)。
   * active / occluded / excluded / invalid / merged / discarded_fragment
   *
   * @generated from field: string geometry_status = 14;
   */
  geometryStatus: string;

  /**
   * 割当前の候補を復元するための記録 (保存形式 2)
   *
   * @generated from field: api_proto.v1.ElevationSurfaceOwnership ownership = 15;
   */
  ownership?: ElevationSurfaceOwnership;

  /**
   * 初回の割当に入力した根拠形 (参照実装 sourceGeometry)。編集で現在の形が変わっても残す
   *
   * @generated from field: repeated api_proto.v1.ElevationRing source_geometry = 16;
   */
  sourceGeometry: ElevationRing[];

  /**
   * バルコニーの面の区分 (参照実装 balconyFaceRole)。front / side / unknown。
   * 解析が 6 色分類の正面・側面から入れ、利用者が画面で変えられる。計算は区分で扱いを変える
   * (正面 = 立上りから裏側・対面を足す / 側面 = 対応する正面の立上り × 横幅 / 未判別 = 足さない)。
   * 空は v4 より前の図面で、参照実装の旧契約どおり正面として扱う。バルコニー以外では空
   *
   * @generated from field: string balcony_face_role = 17;
   */
  balconyFaceRole: string;

  /**
   * 側面が対応する正面の面 id (参照実装 balconyParentId)。区分が side のときだけ意味を持つ。
   * 空なら見えている面積だけを計上する
   *
   * @generated from field: string balcony_parent_id = 18;
   */
  balconyParentId: string;

  /**
   * 開口部の持ち方 (参照実装 openingPolicy)。independent = 開口部は独立した面 (部位 OPENING) で、
   * 内周を開口として数えない (d6e66f2 以降の解析と、画面で足した開口部) / legacy_inner_rings か空 =
   * 旧データで、外壁の内周 (kind が opening のもの) を開口として数える
   *
   * @generated from field: string opening_policy = 19;
   */
  openingPolicy: string;

  /**
   * バルコニーの表側数量に使う、開口部を引く前の割当済み長方形の面積 (px²。参照実装
   * balconyFrontAreaPx2)。計算が書く派生値で、開口部に全体が隠れて geometry_status が occluded の
   * 正面でも数量が残るかの判定に使う。バルコニー以外・未計算では未設定
   *
   * @generated from field: optional double balcony_front_area_px2 = 20;
   */
  balconyFrontAreaPx2?: number;
};

/**
 * Describes the message api_proto.v1.ElevationPolygon.
 * Use `create(ElevationPolygonSchema)` to create a new message.
 */
export const ElevationPolygonSchema: GenMessage<ElevationPolygon> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 9);

/**
 * 共通割当をやり直すために保つ記録 (参照実装 surface_ownership の ownership)。
 *
 * 保存された署名が現在の輪郭と一致すれば「人が形を編集していない」と判断して
 * `input_rings` (割当前の候補) に戻してから割当をやり直す。これがあるおかげで、
 * 覆っていた面を動かす・対象外にする・削除すると、隠れていた領域が戻る。
 *
 * @generated from message api_proto.v1.ElevationSurfaceOwnership
 */
export type ElevationSurfaceOwnership = Message<"api_proto.v1.ElevationSurfaceOwnership"> & {
  /**
   * 参照実装 surface_ownership.VERSION。版が違う記録は使わない
   *
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * 割当後の輪郭の署名 (参照実装 outputSignature)。現在の輪郭と一致したら未編集と見なす
   *
   * @generated from field: string output_signature = 2;
   */
  outputSignature: string;

  /**
   * 割当前の候補
   *
   * @generated from field: repeated api_proto.v1.ElevationRing input_rings = 3;
   */
  inputRings: ElevationRing[];

  /**
   * 参照実装の ownership の全体 (解析・計算が作った dict をそのまま持つ)。
   *
   * 再割当は上の 3 つだけでなく、基礎の統合・破棄の判定 (mergedInto / foundationSelection /
   * foundationMerge)、開口・バルコニーの長方形化の記録、部位・元の候補 id・元図線の根拠数も読む
   * (`surface_ownership.resolve_surfaces` / `foundation_geometry.unify_foundations`)。
   * 落とすと、解析が捨てた基礎の断片が再計算で統合に戻り、立面図の外壁を覆う大きな基礎になる
   * (2026-10-16 にローカルで再現。北面の外壁が 0.31 ㎡ になった)。項目が多く上流の版で変わるので、
   * 型を付けず写しの dict のまま保存する。解析・計算が書き、サーバーが保つ (画面は読まない)。
   * 空なら上の 3 つから組み立てる (2026-10-16 より前に保存した図面)。input_rings も一緒に書く
   * (record を知らない版の Go は record を捨てるので、版の混在中・切り戻し時に割当前の形を失わない
   * ため。二重保存をやめるのは切り戻しの可能性が無くなった次のリリース)
   *
   * @generated from field: google.protobuf.Struct record = 4;
   */
  record?: JsonObject;
};

/**
 * Describes the message api_proto.v1.ElevationSurfaceOwnership.
 * Use `create(ElevationSurfaceOwnershipSchema)` to create a new message.
 */
export const ElevationSurfaceOwnershipSchema: GenMessage<ElevationSurfaceOwnership> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 10);

/**
 * 保存形式 2 の面ごとの来歴 (参照実装 elevation_wall_detector/geometry_state.py)。
 *
 * @generated from message api_proto.v1.ElevationGeometryState
 */
export type ElevationGeometryState = Message<"api_proto.v1.ElevationGeometryState"> & {
  /**
   * 現在は 2
   *
   * @generated from field: int32 schema_version = 1;
   */
  schemaVersion: number;

  /**
   * @generated from field: api_proto.v1.ElevationOutlineReduction outline_reduction = 2;
   */
  outlineReduction?: ElevationOutlineReduction;
};

/**
 * Describes the message api_proto.v1.ElevationGeometryState.
 * Use `create(ElevationGeometryStateSchema)` to create a new message.
 */
export const ElevationGeometryStateSchema: GenMessage<ElevationGeometryState> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 11);

/**
 * 外周の削減状態。記録が無い点数は未設定 (参照実装は null)。
 *
 * @generated from message api_proto.v1.ElevationOutlineReduction
 */
export type ElevationOutlineReduction = Message<"api_proto.v1.ElevationOutlineReduction"> & {
  /**
   * not_recorded / not_applied / unchanged / reduced / manual_edited
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: optional int32 original_vertex_count = 2;
   */
  originalVertexCount?: number;

  /**
   * @generated from field: optional int32 candidate_vertex_count = 3;
   */
  candidateVertexCount?: number;

  /**
   * 外周の座標から都度求める
   *
   * @generated from field: int32 current_vertex_count = 4;
   */
  currentVertexCount: number;
};

/**
 * Describes the message api_proto.v1.ElevationOutlineReduction.
 * Use `create(ElevationOutlineReductionSchema)` to create a new message.
 */
export const ElevationOutlineReductionSchema: GenMessage<ElevationOutlineReduction> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 12);

/**
 * 縮尺の解決結果。
 *
 * @generated from message api_proto.v1.ElevationScale
 */
export type ElevationScale = Message<"api_proto.v1.ElevationScale"> & {
  /**
   * @generated from field: double m_per_px = 1;
   */
  mPerPx: number;

  /**
   * 例: pdf_dpi_and_declared_scale
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * 1/100 なら 100
   *
   * @generated from field: int32 scale_denominator = 3;
   */
  scaleDenominator: number;

  /**
   * @generated from field: api_proto.v1.ElevationScaleStatus status = 4;
   */
  status: ElevationScaleStatus;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.ElevationScale.
 * Use `create(ElevationScaleSchema)` to create a new message.
 */
export const ElevationScaleSchema: GenMessage<ElevationScale> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 13);

/**
 * 屋根勾配の入力行 (屋根ポリゴンごと)。
 * degrees が正ならそれを優先し、無ければ rise/run (寸勾配: run=10, rise=4 で 4寸)。
 *
 * @generated from message api_proto.v1.ElevationRoofSlope
 */
export type ElevationRoofSlope = Message<"api_proto.v1.ElevationRoofSlope"> & {
  /**
   * 対象の屋根ポリゴン
   *
   * @generated from field: string polygon_id = 1;
   */
  polygonId: string;

  /**
   * @generated from field: double rise = 2;
   */
  rise: number;

  /**
   * 既定 10。参照実装 (pydantic RoofSlopeInput) はフィールド未指定時に 10.0 を既定値として
   * 埋めるが、proto の scalar field は「未指定」と「明示的な 0」を区別できない。
   * そのためサーバー側 (Python の calculation.calculate) では 0 (以下) を常に「未指定」とみなし、
   * 既定値 10 を使う。参照実装で run=0 を明示送信した場合は既定値化されず 0 のまま
   * 扱われるため (rise/run formula が発火せず勾配なし相当になる)、その 1 点のみ挙動が
   * 意図的に異なる。詳細: python の calculation.py の RoofSlopeInput.run
   *
   * @generated from field: double run = 3;
   */
  run: number;

  /**
   * @generated from field: double degrees = 4;
   */
  degrees: number;

  /**
   * @generated from field: string label = 5;
   */
  label: string;

  /**
   * pdf_text / manual 等
   *
   * @generated from field: string source = 6;
   */
  source: string;
};

/**
 * Describes the message api_proto.v1.ElevationRoofSlope.
 * Use `create(ElevationRoofSlopeSchema)` to create a new message.
 */
export const ElevationRoofSlopeSchema: GenMessage<ElevationRoofSlope> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 14);

/**
 * 屋根勾配の候補 (PDF テキスト + Gemini の読み取り)。
 *
 * @generated from message api_proto.v1.ElevationRoofSlopeCandidate
 */
export type ElevationRoofSlopeCandidate = Message<"api_proto.v1.ElevationRoofSlopeCandidate"> & {
  /**
   * 元の表記 (例 "4寸勾配")
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: double rise = 2;
   */
  rise: number;

  /**
   * @generated from field: double run = 3;
   */
  run: number;

  /**
   * @generated from field: double degrees = 4;
   */
  degrees: number;

  /**
   * @generated from field: double confidence = 5;
   */
  confidence: number;

  /**
   * pdf_text / gemini_pdf
   *
   * @generated from field: string source = 6;
   */
  source: string;

  /**
   * roof / roof_1f / roof_2f
   *
   * @generated from field: api_proto.v1.ElevationPart part = 7;
   */
  part: ElevationPart;

  /**
   * @generated from field: string label = 8;
   */
  label: string;

  /**
   * gemini_pdf のとき使用モデル
   *
   * @generated from field: string model = 9;
   */
  model: string;
};

/**
 * Describes the message api_proto.v1.ElevationRoofSlopeCandidate.
 * Use `create(ElevationRoofSlopeCandidateSchema)` to create a new message.
 */
export const ElevationRoofSlopeCandidateSchema: GenMessage<ElevationRoofSlopeCandidate> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 15);

/**
 * Gemini による屋根勾配読み取りの実行状態 (参照実装 settings.roof_slope_reading)。
 *
 * @generated from message api_proto.v1.ElevationRoofSlopeReading
 */
export type ElevationRoofSlopeReading = Message<"api_proto.v1.ElevationRoofSlopeReading"> & {
  /**
   * not_run / manual_override / missing_api_key / disabled / completed / failed / skipped_non_pdf
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: string model = 2;
   */
  model: string;

  /**
   * @generated from field: int32 candidate_count = 3;
   */
  candidateCount: number;

  /**
   * failed のとき (内部向け。画面にそのまま出さない)
   *
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message api_proto.v1.ElevationRoofSlopeReading.
 * Use `create(ElevationRoofSlopeReadingSchema)` to create a new message.
 */
export const ElevationRoofSlopeReadingSchema: GenMessage<ElevationRoofSlopeReading> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 16);

/**
 * バルコニー手入力 (積算規則 §4.3 の暫定機能)。
 * 図面から確認できない立上り (裏側高さ) を利用者が入力する。
 *
 * @generated from message api_proto.v1.ElevationBalconyInput
 */
export type ElevationBalconyInput = Message<"api_proto.v1.ElevationBalconyInput"> & {
  /**
   * 対応する検出バルコニーポリゴン。手動時は空
   *
   * @generated from field: string polygon_id = 1;
   */
  polygonId: string;

  /**
   * 計上先の方位
   *
   * @generated from field: api_proto.v1.ElevationDirection direction = 2;
   */
  direction: ElevationDirection;

  /**
   * 立上 mm
   *
   * @generated from field: double rise_mm = 3;
   */
  riseMm: number;

  /**
   * 計上するか
   *
   * @generated from field: bool include = 4;
   */
  include: boolean;

  /**
   * 表示名 (任意)
   *
   * @generated from field: string label = 5;
   */
  label: string;
};

/**
 * Describes the message api_proto.v1.ElevationBalconyInput.
 * Use `create(ElevationBalconyInputSchema)` to create a new message.
 */
export const ElevationBalconyInputSchema: GenMessage<ElevationBalconyInput> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 17);

/**
 * バルコニーの側面手入力。側面は立面図に映らない (奥行き方向) ので横長を人が入れる。
 *
 * 側面の方位はバルコニーの方位に直交する 2 つ (南のバルコニー → 東側面・西側面、
 * 東のバルコニー → 南側面・北側面)。面積は「そのバルコニーの立上り + 元の高さ」× 横長 で、
 * polygon_id がどのバルコニーの側面かを表す。
 *
 * polygon_id が空の入力は南のバルコニーの側面として扱う (2026-09 以前に保存された
 * データとの互換。当時は南のバルコニー専用で direction が EAST / WEST 固定だった)。
 *
 * @generated from message api_proto.v1.ElevationBalconySideInput
 */
export type ElevationBalconySideInput = Message<"api_proto.v1.ElevationBalconySideInput"> & {
  /**
   * 計上先の方位 (バルコニーの方位に直交する側)
   *
   * @generated from field: api_proto.v1.ElevationDirection direction = 1;
   */
  direction: ElevationDirection;

  /**
   * 横長 mm
   *
   * @generated from field: double length_mm = 2;
   */
  lengthMm: number;

  /**
   * @generated from field: bool include = 3;
   */
  include: boolean;

  /**
   * 側面の持ち主のバルコニーポリゴン。空なら南のバルコニー (旧データ)
   *
   * @generated from field: string polygon_id = 4;
   */
  polygonId: string;
};

/**
 * Describes the message api_proto.v1.ElevationBalconySideInput.
 * Use `create(ElevationBalconySideInputSchema)` to create a new message.
 */
export const ElevationBalconySideInputSchema: GenMessage<ElevationBalconySideInput> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 18);

/**
 * 方位分割の結果 (ページ内の各方位の範囲)。
 *
 * @generated from message api_proto.v1.ElevationRegion
 */
export type ElevationRegion = Message<"api_proto.v1.ElevationRegion"> & {
  /**
   * @generated from field: api_proto.v1.ElevationDirection direction = 1;
   */
  direction: ElevationDirection;

  /**
   * ページ px の [left, top, right, bottom]
   *
   * @generated from field: repeated int32 bbox_px = 2;
   */
  bboxPx: number[];
};

/**
 * Describes the message api_proto.v1.ElevationRegion.
 * Use `create(ElevationRegionSchema)` to create a new message.
 */
export const ElevationRegionSchema: GenMessage<ElevationRegion> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 19);

/**
 * 図面 1 枚の編集状態一式。current_geometry_json 列へ protojson で保存する。
 *
 * @generated from message api_proto.v1.ElevationDrawingState
 */
export type ElevationDrawingState = Message<"api_proto.v1.ElevationDrawingState"> & {
  /**
   * "2.0"
   *
   * @generated from field: string schema_version = 1;
   */
  schemaVersion: string;

  /**
   * @generated from field: api_proto.v1.ElevationImageSize image = 2;
   */
  image?: ElevationImageSize;

  /**
   * @generated from field: api_proto.v1.ElevationScale scale = 3;
   */
  scale?: ElevationScale;

  /**
   * @generated from field: repeated api_proto.v1.ElevationPolygon polygons = 4;
   */
  polygons: ElevationPolygon[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationRoofSlope roof_slopes = 5;
   */
  roofSlopes: ElevationRoofSlope[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationRoofSlopeCandidate roof_slope_candidates = 6;
   */
  roofSlopeCandidates: ElevationRoofSlopeCandidate[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationBalconyInput balcony_inputs = 7;
   */
  balconyInputs: ElevationBalconyInput[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationBalconySideInput balcony_side_inputs = 8;
   */
  balconySideInputs: ElevationBalconySideInput[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationRegion regions = 9;
   */
  regions: ElevationRegion[];

  /**
   * コーキング長の計算に使う外壁材の隙間線 (利用者が指定)
   *
   * @generated from field: repeated api_proto.v1.ElevationCaulkingGapSegment caulking_gap_segments = 10;
   */
  caulkingGapSegments: ElevationCaulkingGapSegment[];

  /**
   * 実寸校正。指定されると全ポリゴンの m/px をこの辺から求め、scale.m_per_px は使わない
   *
   * @generated from field: api_proto.v1.ElevationEdgeCalibration scale_calibration = 11;
   */
  scaleCalibration?: ElevationEdgeCalibration;

  /**
   * 解析前の歪み補正の判定結果 (表示用)
   *
   * @generated from field: api_proto.v1.ElevationRectification rectification = 12;
   */
  rectification?: ElevationRectification;

  /**
   * @generated from field: api_proto.v1.ElevationRoofSlopeReading roof_slope_reading = 13;
   */
  roofSlopeReading?: ElevationRoofSlopeReading;

  /**
   * 保存形式の版 (参照実装 geometrySchemaVersion)。形式 2 以降は面の来歴と台帳を持つ
   *
   * @generated from field: int32 geometry_schema_version = 14;
   */
  geometrySchemaVersion: number;

  /**
   * 共通割当の台帳 (参照実装 surfaceLedger)。完全に隠れた面・統合された面・対象外・
   * 不正な面を、有効な面 (polygons) と分けて保持する。計算の入力にもなる: 計算は台帳の行を
   * 先に並べ、同じ id の polygons で上書きしてから割当をやり直す (覆われた面を戻すのに要る)
   *
   * @generated from field: repeated api_proto.v1.ElevationPolygon surface_ledger = 15;
   */
  surfaceLedger: ElevationPolygon[];

  /**
   * 軒天・破風・雨樋・水切り板金の手動入力 (参照実装 manualMaterials。雨樋はいえサプリ独自の追加)。
   * 図面上の 2 点で位置を指定し、軒天は長さ × 奥行きの面積、破風・雨樋・水切り板金は長さで集計する。
   * 外壁・屋根の面積とは別
   *
   * @generated from field: repeated api_proto.v1.ElevationManualMaterial manual_materials = 16;
   */
  manualMaterials: ElevationManualMaterial[];
};

/**
 * Describes the message api_proto.v1.ElevationDrawingState.
 * Use `create(ElevationDrawingStateSchema)` to create a new message.
 */
export const ElevationDrawingStateSchema: GenMessage<ElevationDrawingState> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 20);

/**
 * 手動部材 1 件 (参照実装 manual_materials.ManualMaterialPayload)。
 *
 * @generated from message api_proto.v1.ElevationManualMaterial
 */
export type ElevationManualMaterial = Message<"api_proto.v1.ElevationManualMaterial"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * soffit (軒天) / fascia (破風) / gutter (雨樋) / flashing (水切り板金)
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * 集計先の方位。全体 (FULL_PAGE) も選べる
   *
   * @generated from field: api_proto.v1.ElevationDirection direction = 3;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * 図面ページ px
   *
   * @generated from field: api_proto.v1.ElevationPoint start = 5;
   */
  start?: ElevationPoint;

  /**
   * @generated from field: api_proto.v1.ElevationPoint end = 6;
   */
  end?: ElevationPoint;

  /**
   * 旧データの実測の長さ (mm)。画面に入力欄が無く、見えない値が図面の長さを上書きしていたため、
   * 計算には使わない (長さは常に図面の 2 点 × 縮尺)。保存時に Go が外す。旧データの読み込み互換のため残す
   *
   * @generated from field: optional double actual_length_mm = 7;
   */
  actualLengthMm?: number;

  /**
   * 軒天の奥行き (mm)。軒天にだけ指定でき、未入力の軒天は数量が出ない
   *
   * @generated from field: optional double depth_mm = 8;
   */
  depthMm?: number;

  /**
   * 集計に含めるか
   *
   * @generated from field: bool include = 9;
   */
  include: boolean;
};

/**
 * Describes the message api_proto.v1.ElevationManualMaterial.
 * Use `create(ElevationManualMaterialSchema)` to create a new message.
 */
export const ElevationManualMaterialSchema: GenMessage<ElevationManualMaterial> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 21);

/**
 * 外壁材の隙間線 (目地) 1 本。始点・終点はページ px。縦目地・横目地のどちらも引ける
 * (画面は水平又は垂直に補正して送る。計算が拒否するのは長さ 0 だけ)。
 *
 * @generated from message api_proto.v1.ElevationCaulkingGapSegment
 */
export type ElevationCaulkingGapSegment = Message<"api_proto.v1.ElevationCaulkingGapSegment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 集計先の方位
   *
   * @generated from field: api_proto.v1.ElevationDirection direction = 2;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: api_proto.v1.ElevationPoint start = 3;
   */
  start?: ElevationPoint;

  /**
   * @generated from field: api_proto.v1.ElevationPoint end = 4;
   */
  end?: ElevationPoint;
};

/**
 * Describes the message api_proto.v1.ElevationCaulkingGapSegment.
 * Use `create(ElevationCaulkingGapSegmentSchema)` to create a new message.
 */
export const ElevationCaulkingGapSegmentSchema: GenMessage<ElevationCaulkingGapSegment> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 22);

/**
 * ポリゴンの 1 辺とその実寸。m/px = real_length_mm / 1000 / 辺の px 長。
 * 辺の px 長は計算のたびに現在のリングから求める (辺を編集すると縮尺も追随する)。
 *
 * 保存時 (go/logic/elevation.MergeEditableState) に polygon_id / ring_id / edge_index が
 * 現在の polygons に実在するかを検査し、対象ポリゴン・リングが削除されていれば校正自体を
 * 落とす (nil にする)。ただし「辺が指す頂点は編集で変わったが edge_index は依然として
 * 範囲内」なケース (例: 頂点を削除して同じ index が別の辺を指すようになった) は検出できない
 * — この message は保存時点の辺の px 長を保持しないため、「辺の形状が変わったか」を
 * 判定する基準を持たない。検出するには保存時の px 長 (または頂点の識別子) を別途
 * 保持するフィールド追加が必要 (未実装。既知の限界として明記する)。
 *
 * @generated from message api_proto.v1.ElevationEdgeCalibration
 */
export type ElevationEdgeCalibration = Message<"api_proto.v1.ElevationEdgeCalibration"> & {
  /**
   * @generated from field: string polygon_id = 1;
   */
  polygonId: string;

  /**
   * @generated from field: string ring_id = 2;
   */
  ringId: string;

  /**
   * points[edge_index] → points[(edge_index+1) % n]
   *
   * @generated from field: int32 edge_index = 3;
   */
  edgeIndex: number;

  /**
   * @generated from field: double real_length_mm = 4;
   */
  realLengthMm: number;
};

/**
 * Describes the message api_proto.v1.ElevationEdgeCalibration.
 * Use `create(ElevationEdgeCalibrationSchema)` to create a new message.
 */
export const ElevationEdgeCalibrationSchema: GenMessage<ElevationEdgeCalibration> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 23);

/**
 * 解析前の歪み補正 (参照実装 input.rectification の要約)。
 *
 * @generated from message api_proto.v1.ElevationRectification
 */
export type ElevationRectification = Message<"api_proto.v1.ElevationRectification"> & {
  /**
   * native_vector / raster_scan / ocr_raster_scan / hybrid_or_unknown
   *
   * @generated from field: string source_kind = 1;
   */
  sourceKind: string;

  /**
   * 例: keystone / local_mesh
   *
   * @generated from field: repeated string distortion_types = 2;
   */
  distortionTypes: string[];

  /**
   * 例: not_required / applied / applied_unverified
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: bool applied = 4;
   */
  applied: boolean;
};

/**
 * Describes the message api_proto.v1.ElevationRectification.
 * Use `create(ElevationRectificationSchema)` to create a new message.
 */
export const ElevationRectificationSchema: GenMessage<ElevationRectification> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 24);

/**
 * 計算結果の 1 行 (参照実装 /api/calculate の行・合計と同一キー)。
 *
 * @generated from message api_proto.v1.ElevationAreaRow
 */
export type ElevationAreaRow = Message<"api_proto.v1.ElevationAreaRow"> & {
  /**
   * 合計行は UNSPECIFIED
   *
   * @generated from field: api_proto.v1.ElevationDirection direction = 1;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: string direction_label = 2;
   */
  directionLabel: string;

  /**
   * ネット外壁 (外周 − 開口)
   *
   * @generated from field: double polygon_area_m2 = 3;
   */
  polygonAreaM2: number;

  /**
   * 検出バルコニー
   *
   * @generated from field: double balcony_polygon_area_m2 = 4;
   */
  balconyPolygonAreaM2: number;

  /**
   * 屋根立面投影
   *
   * @generated from field: double roof_vertical_projection_area_m2 = 5;
   */
  roofVerticalProjectionAreaM2: number;

  /**
   * 屋根水平投影 (立面投影 ÷ 勾配)
   *
   * @generated from field: double roof_polygon_area_m2 = 6;
   */
  roofPolygonAreaM2: number;

  /**
   * 実効勾配係数 (material ÷ horizontal)
   *
   * @generated from field: double roof_slope_factor = 7;
   */
  roofSlopeFactor: number;

  /**
   * 屋根材面積 (水平投影 × 勾配係数)
   *
   * @generated from field: double roof_material_area_m2 = 8;
   */
  roofMaterialAreaM2: number;

  /**
   * @generated from field: double roof_1f_vertical_projection_area_m2 = 9;
   */
  roof1fVerticalProjectionAreaM2: number;

  /**
   * @generated from field: double roof_1f_polygon_area_m2 = 10;
   */
  roof1fPolygonAreaM2: number;

  /**
   * @generated from field: double roof_1f_material_area_m2 = 11;
   */
  roof1fMaterialAreaM2: number;

  /**
   * @generated from field: double roof_2f_vertical_projection_area_m2 = 12;
   */
  roof2fVerticalProjectionAreaM2: number;

  /**
   * @generated from field: double roof_2f_polygon_area_m2 = 13;
   */
  roof2fPolygonAreaM2: number;

  /**
   * @generated from field: double roof_2f_material_area_m2 = 14;
   */
  roof2fMaterialAreaM2: number;

  /**
   * 勾配未入力の屋根ポリゴン数
   *
   * @generated from field: int32 roof_slope_missing_count = 15;
   */
  roofSlopeMissingCount: number;

  /**
   * 外周長
   *
   * @generated from field: double perimeter_m = 16;
   */
  perimeterM: number;

  /**
   * 手入力バルコニー (include=true)
   *
   * @generated from field: double manual_balcony_m2 = 17;
   */
  manualBalconyM2: number;

  /**
   * 手入力バルコニー (include=false)
   *
   * @generated from field: double excluded_manual_balcony_m2 = 18;
   */
  excludedManualBalconyM2: number;

  /**
   * 外壁系合計 = ネット外壁 + 検出バルコニー + 手入力
   *
   * @generated from field: double wall_final_area_m2 = 19;
   */
  wallFinalAreaM2: number;

  /**
   * 現状 wall_final_area_m2 と同値
   *
   * @generated from field: double final_area_m2 = 20;
   */
  finalAreaM2: number;

  /**
   * バルコニー手入力の内訳 (include=true 分)。manual_balcony_m2 = back + opposite_net + side
   *
   * 裏側 = 立上 × 対象長
   *
   * @generated from field: double balcony_back_area_m2 = 21;
   */
  balconyBackAreaM2: number;

  /**
   * 対面 (控除前) = 裏側と同値
   *
   * @generated from field: double balcony_opposite_gross_area_m2 = 22;
   */
  balconyOppositeGrossAreaM2: number;

  /**
   * 対面の窓控除
   *
   * @generated from field: double balcony_window_deduction_area_m2 = 23;
   */
  balconyWindowDeductionAreaM2: number;

  /**
   * 対面 (控除後)
   *
   * @generated from field: double balcony_opposite_net_area_m2 = 24;
   */
  balconyOppositeNetAreaM2: number;

  /**
   * バルコニー側面の手入力ぶん
   *
   * @generated from field: double balcony_side_area_m2 = 25;
   */
  balconySideAreaM2: number;

  /**
   * 検出バルコニー + 手入力
   *
   * @generated from field: double balcony_total_area_m2 = 26;
   */
  balconyTotalAreaM2: number;

  /**
   * コーキング
   *
   * 開口部の周長合計
   *
   * @generated from field: double opening_length_m = 27;
   */
  openingLengthM: number;

  /**
   * 隙間線の有効長 (開口と重なる分を除く)
   *
   * @generated from field: double wall_gap_length_m = 28;
   */
  wallGapLengthM: number;

  /**
   * opening + wall_gap
   *
   * @generated from field: double caulking_length_m = 29;
   */
  caulkingLengthM: number;

  /**
   * 基礎 (外壁・バルコニーとは別集計。参照実装 foundationAreaM2 / foundationPolygonCount)。
   * 件数 0 は「未検出」、v4 より前の結果では両方 0
   *
   * @generated from field: double foundation_area_m2 = 30;
   */
  foundationAreaM2: number;

  /**
   * @generated from field: int32 foundation_polygon_count = 31;
   */
  foundationPolygonCount: number;

  /**
   * 開口部を含む総面積 (参照実装 area_totals.gross_area_fields)。外壁洗浄など開口部込みで
   * 見積もる用途向け。基礎・バルコニーは含めない
   *
   * 開口部面積
   *
   * @generated from field: double opening_area_m2 = 32;
   */
  openingAreaM2: number;

  /**
   * 外壁総面積 = 外壁 (開口部控除後) + 開口部
   *
   * @generated from field: double exterior_wall_gross_area_m2 = 33;
   */
  exteriorWallGrossAreaM2: number;

  /**
   * 全体総面積 = 外壁総面積 + 屋根材。屋根の勾配不足・屋根未検出のときは確定しないので空
   *
   * @generated from field: optional double overall_gross_area_m2 = 34;
   */
  overallGrossAreaM2?: number;

  /**
   * 計算済み部分の小計
   *
   * @generated from field: double known_overall_gross_area_m2 = 35;
   */
  knownOverallGrossAreaM2: number;

  /**
   * complete / roof_slope_missing / roof_not_detected
   *
   * @generated from field: string overall_gross_area_status = 36;
   */
  overallGrossAreaStatus: string;
};

/**
 * Describes the message api_proto.v1.ElevationAreaRow.
 * Use `create(ElevationAreaRowSchema)` to create a new message.
 */
export const ElevationAreaRowSchema: GenMessage<ElevationAreaRow> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 25);

/**
 * バルコニー手入力 1 件の計算内訳。
 *
 * @generated from message api_proto.v1.ElevationBalconyDetail
 */
export type ElevationBalconyDetail = Message<"api_proto.v1.ElevationBalconyDetail"> & {
  /**
   * @generated from field: string polygon_id = 1;
   */
  polygonId: string;

  /**
   * @generated from field: api_proto.v1.ElevationDirection direction = 2;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: string direction_label = 3;
   */
  directionLabel: string;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: bool include = 5;
   */
  include: boolean;

  /**
   * @generated from field: double back_area_m2 = 6;
   */
  backAreaM2: number;

  /**
   * @generated from field: double opposite_gross_area_m2 = 7;
   */
  oppositeGrossAreaM2: number;

  /**
   * @generated from field: double window_deduction_area_m2 = 8;
   */
  windowDeductionAreaM2: number;

  /**
   * @generated from field: double opposite_net_area_m2 = 9;
   */
  oppositeNetAreaM2: number;

  /**
   * @generated from field: double side_area_m2 = 10;
   */
  sideAreaM2: number;

  /**
   * @generated from field: double total_area_m2 = 11;
   */
  totalAreaM2: number;

  /**
   * @generated from field: bool is_detected_balcony = 12;
   */
  isDetectedBalcony: boolean;

  /**
   * 窓控除に使った範囲 (裏側と開口部が重なる部分。画面のハッチング)。計算の橋渡しが、
   * 参照実装 d6e66f2 の返す裏側の長方形 (balconyBackBounds) と開口部を引いた後の裏側
   * (balconyBackRings) の差として求めて写す。v4〜d6e66f2 取り込み前は空で、その間は画面が
   * 図から求め直していた。それより前に計算した結果は計算し直すまで空 (ハッチングが出ない)
   *
   * @generated from field: repeated api_proto.v1.ElevationBalconyWindowProjection deduction_ranges = 13;
   */
  deductionRanges: ElevationBalconyWindowProjection[];
};

/**
 * Describes the message api_proto.v1.ElevationBalconyDetail.
 * Use `create(ElevationBalconyDetailSchema)` to create a new message.
 */
export const ElevationBalconyDetailSchema: GenMessage<ElevationBalconyDetail> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 26);

/**
 * 隙間線のうち、計算に入らないため長さから除いた区間。画面で「ここは計算に入らない」と
 * 示すためだけに返す（長さの正は excluded_length_m / effective_length_m）。
 * 計算に入るのは外壁の面の内側かつ開口部の外側だけで（バルコニーは「外壁でない面」として
 * 除外側に入る。v3 までは Go が外壁とバルコニーの両方を数えていた）、面の外（屋根・面のない
 * 空白）と開口部の内側はどちらも除く。面と開口部の集め方は幅があり（内周リング・元図線の
 * 開口部・外周の切り欠き）、クライアントで再現すると判定がずれるため区間もサーバーが返す。
 *
 * @generated from message api_proto.v1.ElevationCaulkingGapExcludedRange
 */
export type ElevationCaulkingGapExcludedRange = Message<"api_proto.v1.ElevationCaulkingGapExcludedRange"> & {
  /**
   * @generated from field: api_proto.v1.ElevationPoint start = 1;
   */
  start?: ElevationPoint;

  /**
   * @generated from field: api_proto.v1.ElevationPoint end = 2;
   */
  end?: ElevationPoint;
};

/**
 * Describes the message api_proto.v1.ElevationCaulkingGapExcludedRange.
 * Use `create(ElevationCaulkingGapExcludedRangeSchema)` to create a new message.
 */
export const ElevationCaulkingGapExcludedRangeSchema: GenMessage<ElevationCaulkingGapExcludedRange> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 27);

/**
 * 隙間線 1 本の計算内訳。
 *
 * @generated from message api_proto.v1.ElevationCaulkingGapSegmentResult
 */
export type ElevationCaulkingGapSegmentResult = Message<"api_proto.v1.ElevationCaulkingGapSegmentResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: api_proto.v1.ElevationDirection direction = 2;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: string direction_label = 3;
   */
  directionLabel: string;

  /**
   * @generated from field: double requested_length_m = 4;
   */
  requestedLengthM: number;

  /**
   * 計算に入らない長さの合計（面の外＋開口部の内側）。番号 5 は旧 excluded_by_openings_m で、
   * 除外が開口部だけだった頃の名前。意味が広がったので改名した（社内 API のため同一 PR で
   * 全呼び出し元を更新。既に計算済みの図面は計算し直すまでこの値が 0 に見える）
   *
   * @generated from field: double excluded_length_m = 5;
   */
  excludedLengthM: number;

  /**
   * @generated from field: double effective_length_m = 6;
   */
  effectiveLengthM: number;

  /**
   * @generated from field: repeated api_proto.v1.ElevationCaulkingGapExcludedRange excluded_ranges = 7;
   */
  excludedRanges: ElevationCaulkingGapExcludedRange[];
};

/**
 * Describes the message api_proto.v1.ElevationCaulkingGapSegmentResult.
 * Use `create(ElevationCaulkingGapSegmentResultSchema)` to create a new message.
 */
export const ElevationCaulkingGapSegmentResultSchema: GenMessage<ElevationCaulkingGapSegmentResult> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 28);

/**
 * @generated from message api_proto.v1.ElevationCaulkingResult
 */
export type ElevationCaulkingResult = Message<"api_proto.v1.ElevationCaulkingResult"> & {
  /**
   * @generated from field: double opening_length_m = 1;
   */
  openingLengthM: number;

  /**
   * @generated from field: double wall_gap_length_m = 2;
   */
  wallGapLengthM: number;

  /**
   * @generated from field: double total_length_m = 3;
   */
  totalLengthM: number;

  /**
   * @generated from field: repeated api_proto.v1.ElevationCaulkingGapSegmentResult gap_segments = 4;
   */
  gapSegments: ElevationCaulkingGapSegmentResult[];
};

/**
 * Describes the message api_proto.v1.ElevationCaulkingResult.
 * Use `create(ElevationCaulkingResultSchema)` to create a new message.
 */
export const ElevationCaulkingResultSchema: GenMessage<ElevationCaulkingResult> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 29);

/**
 * 計算に使った縮尺。
 *
 * @generated from message api_proto.v1.ElevationCalculatedScale
 */
export type ElevationCalculatedScale = Message<"api_proto.v1.ElevationCalculatedScale"> & {
  /**
   * @generated from field: double m_per_px = 1;
   */
  mPerPx: number;

  /**
   * declared_scale (1/N) / edge_calibration
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * edge_calibration のとき
   *
   * @generated from field: api_proto.v1.ElevationEdgeCalibration calibration = 3;
   */
  calibration?: ElevationEdgeCalibration;

  /**
   * @generated from field: double calibration_pixel_length_px = 4;
   */
  calibrationPixelLengthPx: number;
};

/**
 * Describes the message api_proto.v1.ElevationCalculatedScale.
 * Use `create(ElevationCalculatedScaleSchema)` to create a new message.
 */
export const ElevationCalculatedScaleSchema: GenMessage<ElevationCalculatedScale> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 30);

/**
 * 面積計算結果。行順は south, east, north, west, full_page 固定。
 *
 * @generated from message api_proto.v1.ElevationAreaResult
 */
export type ElevationAreaResult = Message<"api_proto.v1.ElevationAreaResult"> & {
  /**
   * @generated from field: repeated api_proto.v1.ElevationAreaRow rows = 1;
   */
  rows: ElevationAreaRow[];

  /**
   * @generated from field: api_proto.v1.ElevationAreaRow totals = 2;
   */
  totals?: ElevationAreaRow;

  /**
   * 計算に使った編集状態の SHA-256 (hex)。再実行の一致確認と dirty 判定に使う
   *
   * @generated from field: string state_hash = 3;
   */
  stateHash: string;

  /**
   * @generated from field: google.protobuf.Timestamp calculated_at = 4;
   */
  calculatedAt?: Timestamp;

  /**
   * @generated from field: repeated api_proto.v1.ElevationBalconyDetail balcony_details = 5;
   */
  balconyDetails: ElevationBalconyDetail[];

  /**
   * @generated from field: api_proto.v1.ElevationCaulkingResult caulking = 6;
   */
  caulking?: ElevationCaulkingResult;

  /**
   * @generated from field: api_proto.v1.ElevationCalculatedScale scale = 7;
   */
  scale?: ElevationCalculatedScale;

  /**
   * 共通割当の結果 (参照実装 area_totals.calculation_geometry_payload)。
   * 保存・編集・着色・面積・開口・目地が同じ領域を基準にするための正本
   *
   * @generated from field: api_proto.v1.ElevationCalculationGeometry calculation_geometry = 8;
   */
  calculationGeometry?: ElevationCalculationGeometry;

  /**
   * 手動部材の数量 (参照実装 manualMaterials)。手動部材が無ければ空
   *
   * @generated from field: api_proto.v1.ElevationManualMaterialResult manual_materials = 9;
   */
  manualMaterials?: ElevationManualMaterialResult;
};

/**
 * Describes the message api_proto.v1.ElevationAreaResult.
 * Use `create(ElevationAreaResultSchema)` to create a new message.
 */
export const ElevationAreaResultSchema: GenMessage<ElevationAreaResult> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 31);

/**
 * 手動部材の計算結果。
 *
 * @generated from message api_proto.v1.ElevationManualMaterialResult
 */
export type ElevationManualMaterialResult = Message<"api_proto.v1.ElevationManualMaterialResult"> & {
  /**
   * @generated from field: repeated api_proto.v1.ElevationManualMaterialItemResult items = 1;
   */
  items: ElevationManualMaterialItemResult[];

  /**
   * 方位 × 部材ごと
   *
   * @generated from field: repeated api_proto.v1.ElevationManualMaterialSummary rows = 2;
   */
  rows: ElevationManualMaterialSummary[];

  /**
   * 部材ごと (軒天・破風・雨樋・水切り板金の順)
   *
   * @generated from field: repeated api_proto.v1.ElevationManualMaterialSummary totals = 3;
   */
  totals: ElevationManualMaterialSummary[];
};

/**
 * Describes the message api_proto.v1.ElevationManualMaterialResult.
 * Use `create(ElevationManualMaterialResultSchema)` to create a new message.
 */
export const ElevationManualMaterialResultSchema: GenMessage<ElevationManualMaterialResult> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 32);

/**
 * @generated from message api_proto.v1.ElevationManualMaterialItemResult
 */
export type ElevationManualMaterialItemResult = Message<"api_proto.v1.ElevationManualMaterialItemResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: api_proto.v1.ElevationDirection direction = 3;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * 図面上の長さ
   *
   * @generated from field: double image_length_m = 5;
   */
  imageLengthM: number;

  /**
   * 集計に使った長さ (実測があればそれ)
   *
   * @generated from field: double length_m = 6;
   */
  lengthM: number;

  /**
   * actual_input / drawing
   *
   * @generated from field: string length_source = 7;
   */
  lengthSource: string;

  /**
   * 軒天で奥行きがあるときだけ
   *
   * @generated from field: optional double area_m2 = 8;
   */
  areaM2?: number;

  /**
   * 軒天は面積、ほかは長さ。軒天の奥行きが未入力なら空
   *
   * @generated from field: optional double quantity = 9;
   */
  quantity?: number;

  /**
   * m² / m
   *
   * @generated from field: string unit = 10;
   */
  unit: string;

  /**
   * complete / depth_missing / excluded
   *
   * @generated from field: string status = 11;
   */
  status: string;

  /**
   * @generated from field: bool include = 12;
   */
  include: boolean;
};

/**
 * Describes the message api_proto.v1.ElevationManualMaterialItemResult.
 * Use `create(ElevationManualMaterialItemResultSchema)` to create a new message.
 */
export const ElevationManualMaterialItemResultSchema: GenMessage<ElevationManualMaterialItemResult> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 33);

/**
 * @generated from message api_proto.v1.ElevationManualMaterialSummary
 */
export type ElevationManualMaterialSummary = Message<"api_proto.v1.ElevationManualMaterialSummary"> & {
  /**
   * rows のときだけ
   *
   * @generated from field: api_proto.v1.ElevationDirection direction = 1;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * 数量。奥行き未入力の軒天を含むと確定しないので空 (計算済み分は known_quantity)
   *
   * @generated from field: optional double quantity = 3;
   */
  quantity?: number;

  /**
   * @generated from field: double known_quantity = 4;
   */
  knownQuantity: number;

  /**
   * @generated from field: string unit = 5;
   */
  unit: string;

  /**
   * @generated from field: int32 missing_dimension_count = 6;
   */
  missingDimensionCount: number;

  /**
   * @generated from field: int32 included_count = 7;
   */
  includedCount: number;
};

/**
 * Describes the message api_proto.v1.ElevationManualMaterialSummary.
 * Use `create(ElevationManualMaterialSummarySchema)` to create a new message.
 */
export const ElevationManualMaterialSummarySchema: GenMessage<ElevationManualMaterialSummary> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 34);

/**
 * 共通割当の結果。面ごとの内訳と、方位ごとの開口領域を返す。
 *
 * @generated from message api_proto.v1.ElevationCalculationGeometry
 */
export type ElevationCalculationGeometry = Message<"api_proto.v1.ElevationCalculationGeometry"> & {
  /**
   * 参照実装は 6 (d6e66f2 で独立した開口部へ。v4 は 3)
   *
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * page_px
   *
   * @generated from field: string coordinate_space = 2;
   */
  coordinateSpace: string;

  /**
   * 面積に使う開口領域 (方位ごと)
   *
   * @generated from field: repeated api_proto.v1.ElevationDirectionRings openings = 3;
   */
  openings: ElevationDirectionRings[];

  /**
   * 目地の周長に使う、閉鎖条件を満たす開口領域
   *
   * @generated from field: repeated api_proto.v1.ElevationDirectionRings caulking_openings = 4;
   */
  caulkingOpenings: ElevationDirectionRings[];

  /**
   * 縦線の控除と表示に使う開口領域 (閉じていない開口も含む)
   *
   * @generated from field: repeated api_proto.v1.ElevationDirectionRings caulking_line_openings = 5;
   */
  caulkingLineOpenings: ElevationDirectionRings[];

  /**
   * 重なりの優先順 (foundation → balcony → roof_2f → roof_1f → roof → exterior_wall)
   *
   * @generated from field: repeated string ownership_order = 6;
   */
  ownershipOrder: string[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationSurfaceGeometry surfaces = 7;
   */
  surfaces: ElevationSurfaceGeometry[];
};

/**
 * Describes the message api_proto.v1.ElevationCalculationGeometry.
 * Use `create(ElevationCalculationGeometrySchema)` to create a new message.
 */
export const ElevationCalculationGeometrySchema: GenMessage<ElevationCalculationGeometry> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 35);

/**
 * 方位ごとのリング集合。
 *
 * @generated from message api_proto.v1.ElevationDirectionRings
 */
export type ElevationDirectionRings = Message<"api_proto.v1.ElevationDirectionRings"> & {
  /**
   * @generated from field: api_proto.v1.ElevationDirection direction = 1;
   */
  direction: ElevationDirection;

  /**
   * @generated from field: repeated api_proto.v1.ElevationRing rings = 2;
   */
  rings: ElevationRing[];
};

/**
 * Describes the message api_proto.v1.ElevationDirectionRings.
 * Use `create(ElevationDirectionRingsSchema)` to create a new message.
 */
export const ElevationDirectionRingsSchema: GenMessage<ElevationDirectionRings> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 36);

/**
 * 面 1 つの割当後の内訳 (px²)。画面の「面ごとの外周と控除」に出すのは
 * outline / opening_deduction / other_surface_deduction / same_part_deduction / net。
 *
 * @generated from message api_proto.v1.ElevationSurfaceGeometry
 */
export type ElevationSurfaceGeometry = Message<"api_proto.v1.ElevationSurfaceGeometry"> & {
  /**
   * @generated from field: string polygon_id = 1;
   */
  polygonId: string;

  /**
   * 外周面積
   *
   * @generated from field: double outline_area_px2 = 2;
   */
  outlineAreaPx2: number;

  /**
   * 開口控除
   *
   * @generated from field: double opening_deduction_area_px2 = 3;
   */
  openingDeductionAreaPx2: number;

  /**
   * 外周切込みの開口
   *
   * @generated from field: double boundary_opening_area_px2 = 4;
   */
  boundaryOpeningAreaPx2: number;

  /**
   * 未所属の空き
   *
   * @generated from field: double unassigned_void_area_px2 = 5;
   */
  unassignedVoidAreaPx2: number;

  /**
   * 他部位控除
   *
   * @generated from field: double other_surface_deduction_area_px2 = 6;
   */
  otherSurfaceDeductionAreaPx2: number;

  /**
   * 同部位控除
   *
   * @generated from field: double same_part_deduction_area_px2 = 7;
   */
  samePartDeductionAreaPx2: number;

  /**
   * 長方形維持の追加控除
   *
   * @generated from field: double rectangle_constraint_deduction_area_px2 = 8;
   */
  rectangleConstraintDeductionAreaPx2: number;

  /**
   * 最終面積 (px²)
   *
   * @generated from field: double net_area_px2 = 9;
   */
  netAreaPx2: number;

  /**
   * 縮尺が決まっているときだけ入る
   *
   * @generated from field: double net_area_m2 = 10;
   */
  netAreaM2: number;

  /**
   * 割当後の形状
   *
   * @generated from field: repeated api_proto.v1.ElevationRing rings = 11;
   */
  rings: ElevationRing[];

  /**
   * バルコニーの表側数量に使う、開口部を引く前の長方形 (面積 px² と形状)。バルコニー以外では未設定
   *
   * @generated from field: optional double balcony_front_area_px2 = 12;
   */
  balconyFrontAreaPx2?: number;

  /**
   * @generated from field: repeated api_proto.v1.ElevationRing balcony_front_rings = 13;
   */
  balconyFrontRings: ElevationRing[];

  /**
   * 外壁の数量から控除したバルコニー対面との重なり (px²)。立上りが正面より高いと、バルコニーの
   * 対面 (内側の外壁) が通常の外壁と重なるため、同じ立面の中で 1 回だけ外壁から引く。
   * 外壁以外では未設定。この変更より前に計算した結果も未設定
   *
   * @generated from field: optional double balcony_opposite_deduction_area_px2 = 14;
   */
  balconyOppositeDeductionAreaPx2?: number;

  /**
   * 外壁の数量に使う面積 (px²) = net_area_px2 − balcony_opposite_deduction_area_px2 (負は 0)。
   * 方位別・合計の外壁 (polygon_area_m2) はこの値で集計する。外壁以外では未設定
   *
   * @generated from field: optional double quantity_net_area_px2 = 15;
   */
  quantityNetAreaPx2?: number;
};

/**
 * Describes the message api_proto.v1.ElevationSurfaceGeometry.
 * Use `create(ElevationSurfaceGeometrySchema)` to create a new message.
 */
export const ElevationSurfaceGeometrySchema: GenMessage<ElevationSurfaceGeometry> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 37);

/**
 * 積算プロジェクト。
 *
 * @generated from message api_proto.v1.AreaEstimationProject
 */
export type AreaEstimationProject = Message<"api_proto.v1.AreaEstimationProject"> & {
  /**
   * ULID (Crockford base32、26文字)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: int64 created_by_staff_id = 4;
   */
  createdByStaffId: bigint;

  /**
   * @generated from field: string created_by_staff_name = 5;
   */
  createdByStaffName: string;

  /**
   * @generated from field: int64 last_modified_by_staff_id = 6;
   */
  lastModifiedByStaffId: bigint;

  /**
   * @generated from field: string last_modified_by_staff_name = 7;
   */
  lastModifiedByStaffName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 8;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 9;
   */
  updated?: Timestamp;

  /**
   * 配下の図面数
   *
   * @generated from field: int32 drawing_count = 10;
   */
  drawingCount: number;

  /**
   * 一覧サムネイル用。無ければ空文字
   *
   * @generated from field: string latest_drawing_image_url = 11;
   */
  latestDrawingImageUrl: string;

  /**
   * 紐付け顧客ID（未設定時は0）。AIカラー (AiColorProject.customer_id) と同じ規約
   *
   * @generated from field: int64 customer_id = 12;
   */
  customerId: bigint;

  /**
   * 一覧・詳細の表示用。customers を JOIN して埋める（未紐付けは空）
   *
   * @generated from field: string customer_name = 13;
   */
  customerName: string;
};

/**
 * Describes the message api_proto.v1.AreaEstimationProject.
 * Use `create(AreaEstimationProjectSchema)` to create a new message.
 */
export const AreaEstimationProjectSchema: GenMessage<AreaEstimationProject> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 38);

/**
 * プロジェクト配下の 1 図面 (PDF の 1 ページ)。
 *
 * @generated from message api_proto.v1.AreaEstimationDrawing
 */
export type AreaEstimationDrawing = Message<"api_proto.v1.AreaEstimationDrawing"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ULID
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * 表示名。既定はアップロードしたファイル名
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 元 PDF の R2 署名 URL。要求元の積算の実効権限が閲覧のみ（readonly）のときは空文字
   *
   * @generated from field: string pdf_url = 4;
   */
  pdfUrl: string;

  /**
   * 解析対象ページ (1-indexed)
   *
   * @generated from field: int32 page_no = 5;
   */
  pageNo: number;

  /**
   * PDF の総ページ数
   *
   * @generated from field: int32 page_count = 6;
   */
  pageCount: number;

  /**
   * ラスター化した PNG の R2 署名 URL (overlay の下地)
   *
   * @generated from field: string image_url = 7;
   */
  imageUrl: string;

  /**
   * @generated from field: api_proto.v1.ElevationAnalysisStatus analysis_status = 8;
   */
  analysisStatus: ElevationAnalysisStatus;

  /**
   * @generated from field: string analysis_error_message = 9;
   */
  analysisErrorMessage: string;

  /**
   * 解析が一部方位のみ成功した等の警告 (analysis_status=COMPLETED でも表示する)
   *
   * @generated from field: repeated string analysis_warnings = 23;
   */
  analysisWarnings: string[];

  /**
   * 編集中の最新状態 (ポリゴン + 縮尺 + 勾配 + 手入力)。解析未完了なら null
   *
   * @generated from field: api_proto.v1.ElevationDrawingState current_state = 10;
   */
  currentState?: ElevationDrawingState;

  /**
   * 最新の面積計算結果。未計算なら null
   *
   * @generated from field: api_proto.v1.ElevationAreaResult latest_area_result = 11;
   */
  latestAreaResult?: ElevationAreaResult;

  /**
   * 最新計算後に状態が変わっているか (true なら再計算ボタンを活性に)
   *
   * @generated from field: bool dirty_since_last_calculation = 12;
   */
  dirtySinceLastCalculation: boolean;

  /**
   * 縮尺分母 (1/100 なら 100)。px↔m 換算の正本。
   * geometry 側にも同じ値が入るが、解析前・解析失敗時は geometry 自体が無いので、
   * 画面が縮尺を読む先はこちらを正とする
   *
   * @generated from field: int32 scale_denom = 21;
   */
  scaleDenom: number;

  /**
   * PDF をラスター化した dpi
   *
   * @generated from field: int32 render_dpi = 22;
   */
  renderDpi: number;

  /**
   * 導出値。scale_denom と render_dpi から算出したもので DB には持たない
   *
   * @generated from field: double px_per_m = 13;
   */
  pxPerM: number;

  /**
   * 楽観ロック用
   *
   * @generated from field: int32 latest_revision_no = 14;
   */
  latestRevisionNo: number;

  /**
   * @generated from field: int64 created_by_staff_id = 15;
   */
  createdByStaffId: bigint;

  /**
   * @generated from field: string created_by_staff_name = 16;
   */
  createdByStaffName: string;

  /**
   * @generated from field: int64 last_modified_by_staff_id = 17;
   */
  lastModifiedByStaffId: bigint;

  /**
   * @generated from field: string last_modified_by_staff_name = 18;
   */
  lastModifiedByStaffName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 19;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 20;
   */
  updated?: Timestamp;
};

/**
 * Describes the message api_proto.v1.AreaEstimationDrawing.
 * Use `create(AreaEstimationDrawingSchema)` to create a new message.
 */
export const AreaEstimationDrawingSchema: GenMessage<AreaEstimationDrawing> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 39);

/**
 * 図面の編集スナップショット。
 *
 * @generated from message api_proto.v1.AreaEstimationDrawingRevision
 */
export type AreaEstimationDrawingRevision = Message<"api_proto.v1.AreaEstimationDrawingRevision"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ULID
   *
   * @generated from field: string drawing_id = 2;
   */
  drawingId: string;

  /**
   * @generated from field: int32 revision_no = 3;
   */
  revisionNo: number;

  /**
   * @generated from field: api_proto.v1.ElevationOperationType operation_type = 4;
   */
  operationType: ElevationOperationType;

  /**
   * @generated from field: api_proto.v1.ElevationDrawingState state = 5;
   */
  state?: ElevationDrawingState;

  /**
   * CALCULATE のときのみ
   *
   * @generated from field: api_proto.v1.ElevationAreaResult area_result = 6;
   */
  areaResult?: ElevationAreaResult;

  /**
   * @generated from field: google.protobuf.Timestamp created = 7;
   */
  created?: Timestamp;
};

/**
 * Describes the message api_proto.v1.AreaEstimationDrawingRevision.
 * Use `create(AreaEstimationDrawingRevisionSchema)` to create a new message.
 */
export const AreaEstimationDrawingRevisionSchema: GenMessage<AreaEstimationDrawingRevision> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 40);

/**
 * @generated from message api_proto.v1.CreateAreaEstimationProjectRequest
 */
export type CreateAreaEstimationProjectRequest = Message<"api_proto.v1.CreateAreaEstimationProjectRequest"> & {
  /**
   * 空でも可。空なら Go 側で「YYYY/MM/DD作成」を採用
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 顧客の指定は AIカラー (CreateAiColorProjectRequest) と同じ規約。
   * 積算は案件を要求しない（顧客だけを作り、案件は作らない。決定 63）。
   * 両方空なら顧客を作らない（customer_id は NULL のまま）。AIカラーの「既定名で作る」は
   * 踏襲しない: 顧客欄は plan_ui_v2 on でだけ出るので、off の空入力で顧客を作ると
   * flag off の挙動が変わるため（決定 80(c)）。
   *
   * 既存顧客をアサイン（0=なし）。優先される
   *
   * @generated from field: int64 customer_id = 2;
   */
  customerId: bigint;

  /**
   * customer_id==0 かつ非空なら新規顧客を作成して紐付け
   *
   * @generated from field: string new_customer_name = 3;
   */
  newCustomerName: string;
};

/**
 * Describes the message api_proto.v1.CreateAreaEstimationProjectRequest.
 * Use `create(CreateAreaEstimationProjectRequestSchema)` to create a new message.
 */
export const CreateAreaEstimationProjectRequestSchema: GenMessage<CreateAreaEstimationProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 41);

/**
 * @generated from message api_proto.v1.CreateAreaEstimationProjectResponse
 */
export type CreateAreaEstimationProjectResponse = Message<"api_proto.v1.CreateAreaEstimationProjectResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationProject project = 1;
   */
  project?: AreaEstimationProject;
};

/**
 * Describes the message api_proto.v1.CreateAreaEstimationProjectResponse.
 * Use `create(CreateAreaEstimationProjectResponseSchema)` to create a new message.
 */
export const CreateAreaEstimationProjectResponseSchema: GenMessage<CreateAreaEstimationProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 42);

/**
 * @generated from message api_proto.v1.ListAreaEstimationProjectsRequest
 */
export type ListAreaEstimationProjectsRequest = Message<"api_proto.v1.ListAreaEstimationProjectsRequest"> & {
  /**
   * 1-indexed
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 既定 20
   *
   * @generated from field: int32 per_page = 2;
   */
  perPage: number;

  /**
   * @generated from field: bool mine_only = 3;
   */
  mineOnly: boolean;
};

/**
 * Describes the message api_proto.v1.ListAreaEstimationProjectsRequest.
 * Use `create(ListAreaEstimationProjectsRequestSchema)` to create a new message.
 */
export const ListAreaEstimationProjectsRequestSchema: GenMessage<ListAreaEstimationProjectsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 43);

/**
 * @generated from message api_proto.v1.ListAreaEstimationProjectsResponse
 */
export type ListAreaEstimationProjectsResponse = Message<"api_proto.v1.ListAreaEstimationProjectsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.AreaEstimationProject data = 1;
   */
  data: AreaEstimationProject[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * @generated from field: int64 total_page = 3;
   */
  totalPage: bigint;
};

/**
 * Describes the message api_proto.v1.ListAreaEstimationProjectsResponse.
 * Use `create(ListAreaEstimationProjectsResponseSchema)` to create a new message.
 */
export const ListAreaEstimationProjectsResponseSchema: GenMessage<ListAreaEstimationProjectsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 44);

/**
 * @generated from message api_proto.v1.GetAreaEstimationProjectRequest
 */
export type GetAreaEstimationProjectRequest = Message<"api_proto.v1.GetAreaEstimationProjectRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.GetAreaEstimationProjectRequest.
 * Use `create(GetAreaEstimationProjectRequestSchema)` to create a new message.
 */
export const GetAreaEstimationProjectRequestSchema: GenMessage<GetAreaEstimationProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 45);

/**
 * @generated from message api_proto.v1.GetAreaEstimationProjectResponse
 */
export type GetAreaEstimationProjectResponse = Message<"api_proto.v1.GetAreaEstimationProjectResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationProject project = 1;
   */
  project?: AreaEstimationProject;

  /**
   * @generated from field: repeated api_proto.v1.AreaEstimationDrawing drawings = 2;
   */
  drawings: AreaEstimationDrawing[];
};

/**
 * Describes the message api_proto.v1.GetAreaEstimationProjectResponse.
 * Use `create(GetAreaEstimationProjectResponseSchema)` to create a new message.
 */
export const GetAreaEstimationProjectResponseSchema: GenMessage<GetAreaEstimationProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 46);

/**
 * @generated from message api_proto.v1.UpdateAreaEstimationProjectRequest
 */
export type UpdateAreaEstimationProjectRequest = Message<"api_proto.v1.UpdateAreaEstimationProjectRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.UpdateAreaEstimationProjectRequest.
 * Use `create(UpdateAreaEstimationProjectRequestSchema)` to create a new message.
 */
export const UpdateAreaEstimationProjectRequestSchema: GenMessage<UpdateAreaEstimationProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 47);

/**
 * @generated from message api_proto.v1.UpdateAreaEstimationProjectResponse
 */
export type UpdateAreaEstimationProjectResponse = Message<"api_proto.v1.UpdateAreaEstimationProjectResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationProject project = 1;
   */
  project?: AreaEstimationProject;
};

/**
 * Describes the message api_proto.v1.UpdateAreaEstimationProjectResponse.
 * Use `create(UpdateAreaEstimationProjectResponseSchema)` to create a new message.
 */
export const UpdateAreaEstimationProjectResponseSchema: GenMessage<UpdateAreaEstimationProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 48);

/**
 * @generated from message api_proto.v1.DeleteAreaEstimationProjectRequest
 */
export type DeleteAreaEstimationProjectRequest = Message<"api_proto.v1.DeleteAreaEstimationProjectRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.DeleteAreaEstimationProjectRequest.
 * Use `create(DeleteAreaEstimationProjectRequestSchema)` to create a new message.
 */
export const DeleteAreaEstimationProjectRequestSchema: GenMessage<DeleteAreaEstimationProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 49);

/**
 * PDF をアップロードして図面として登録し、解析ジョブを enqueue する。
 * analysis_status = PENDING で即時返却し、フロントはポーリングする。
 *
 * PDF のラスター化は Python worker が行う (Go 側に PDF レンダラを持たない)。
 * 総ページ数も worker が数えて callback で返すため、Go はここでは PDF を保存するだけ。
 *
 * @generated from message api_proto.v1.CreateAreaEstimationDrawingRequest
 */
export type CreateAreaEstimationDrawingRequest = Message<"api_proto.v1.CreateAreaEstimationDrawingRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * 立面図のファイル。PDF のほか画像 (PNG / JPEG) も受け付ける (名前は互換のため据え置き)。
   * 画像は縮尺を持たないので、解析後の scale.status は RECALIBRATION_REQUIRED になる
   *
   * @generated from field: api_proto.v1.Upload pdf = 2;
   */
  pdf?: Upload;

  /**
   * 解析対象ページ (1-indexed)。0 なら 1 ページ目
   *
   * @generated from field: int32 page_no = 3;
   */
  pageNo: number;

  /**
   * 縮尺分母。0 なら既定 100 (1/100)
   *
   * @generated from field: int32 scale_denom = 4;
   */
  scaleDenom: number;
};

/**
 * Describes the message api_proto.v1.CreateAreaEstimationDrawingRequest.
 * Use `create(CreateAreaEstimationDrawingRequestSchema)` to create a new message.
 */
export const CreateAreaEstimationDrawingRequestSchema: GenMessage<CreateAreaEstimationDrawingRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 50);

/**
 * @generated from message api_proto.v1.CreateAreaEstimationDrawingResponse
 */
export type CreateAreaEstimationDrawingResponse = Message<"api_proto.v1.CreateAreaEstimationDrawingResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationDrawing drawing = 1;
   */
  drawing?: AreaEstimationDrawing;

  /**
   * 図面追加の課金元（design-6.6-notifications.md §2）。課金モード（credit_ledger_settings。
   * 決定105）が記録モードのときは CREDIT_SOURCE_NONE。
   *
   * @generated from field: api_proto.v1.CreditSource credit_source = 2;
   */
  creditSource: CreditSource;
};

/**
 * Describes the message api_proto.v1.CreateAreaEstimationDrawingResponse.
 * Use `create(CreateAreaEstimationDrawingResponseSchema)` to create a new message.
 */
export const CreateAreaEstimationDrawingResponseSchema: GenMessage<CreateAreaEstimationDrawingResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 51);

/**
 * @generated from message api_proto.v1.GetAreaEstimationDrawingRequest
 */
export type GetAreaEstimationDrawingRequest = Message<"api_proto.v1.GetAreaEstimationDrawingRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.GetAreaEstimationDrawingRequest.
 * Use `create(GetAreaEstimationDrawingRequestSchema)` to create a new message.
 */
export const GetAreaEstimationDrawingRequestSchema: GenMessage<GetAreaEstimationDrawingRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 52);

/**
 * @generated from message api_proto.v1.GetAreaEstimationDrawingResponse
 */
export type GetAreaEstimationDrawingResponse = Message<"api_proto.v1.GetAreaEstimationDrawingResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationDrawing drawing = 1;
   */
  drawing?: AreaEstimationDrawing;
};

/**
 * Describes the message api_proto.v1.GetAreaEstimationDrawingResponse.
 * Use `create(GetAreaEstimationDrawingResponseSchema)` to create a new message.
 */
export const GetAreaEstimationDrawingResponseSchema: GenMessage<GetAreaEstimationDrawingResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 53);

/**
 * 解析ステータスのポーリング用 (軽量レスポンス)。
 *
 * @generated from message api_proto.v1.GetAreaEstimationDrawingAnalysisStatusRequest
 */
export type GetAreaEstimationDrawingAnalysisStatusRequest = Message<"api_proto.v1.GetAreaEstimationDrawingAnalysisStatusRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string drawing_id = 1;
   */
  drawingId: string;
};

/**
 * Describes the message api_proto.v1.GetAreaEstimationDrawingAnalysisStatusRequest.
 * Use `create(GetAreaEstimationDrawingAnalysisStatusRequestSchema)` to create a new message.
 */
export const GetAreaEstimationDrawingAnalysisStatusRequestSchema: GenMessage<GetAreaEstimationDrawingAnalysisStatusRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 54);

/**
 * @generated from message api_proto.v1.GetAreaEstimationDrawingAnalysisStatusResponse
 */
export type GetAreaEstimationDrawingAnalysisStatusResponse = Message<"api_proto.v1.GetAreaEstimationDrawingAnalysisStatusResponse"> & {
  /**
   * @generated from field: api_proto.v1.ElevationAnalysisStatus status = 1;
   */
  status: ElevationAnalysisStatus;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;

  /**
   * 完了時のみ。フロントが即座に描画を始められるよう同梱する
   *
   * @generated from field: api_proto.v1.ElevationDrawingState state = 3;
   */
  state?: ElevationDrawingState;
};

/**
 * Describes the message api_proto.v1.GetAreaEstimationDrawingAnalysisStatusResponse.
 * Use `create(GetAreaEstimationDrawingAnalysisStatusResponseSchema)` to create a new message.
 */
export const GetAreaEstimationDrawingAnalysisStatusResponseSchema: GenMessage<GetAreaEstimationDrawingAnalysisStatusResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 55);

/**
 * 再解析。編集内容が失われる破壊的操作なので、確認モーダルは呼び出し側の責務。
 * ページや縮尺を変えて解析し直す経路も兼ねる。
 *
 * @generated from message api_proto.v1.ReanalyzeAreaEstimationDrawingRequest
 */
export type ReanalyzeAreaEstimationDrawingRequest = Message<"api_proto.v1.ReanalyzeAreaEstimationDrawingRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string drawing_id = 1;
   */
  drawingId: string;

  /**
   * 解析対象ページ (1-indexed)。0 なら現在の page_no を維持
   *
   * @generated from field: int32 page_no = 2;
   */
  pageNo: number;

  /**
   * 縮尺分母。0 なら現在の scale_denom を維持
   *
   * @generated from field: int32 scale_denom = 3;
   */
  scaleDenom: number;
};

/**
 * Describes the message api_proto.v1.ReanalyzeAreaEstimationDrawingRequest.
 * Use `create(ReanalyzeAreaEstimationDrawingRequestSchema)` to create a new message.
 */
export const ReanalyzeAreaEstimationDrawingRequestSchema: GenMessage<ReanalyzeAreaEstimationDrawingRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 56);

/**
 * @generated from message api_proto.v1.ReanalyzeAreaEstimationDrawingResponse
 */
export type ReanalyzeAreaEstimationDrawingResponse = Message<"api_proto.v1.ReanalyzeAreaEstimationDrawingResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationDrawing drawing = 1;
   */
  drawing?: AreaEstimationDrawing;
};

/**
 * Describes the message api_proto.v1.ReanalyzeAreaEstimationDrawingResponse.
 * Use `create(ReanalyzeAreaEstimationDrawingResponseSchema)` to create a new message.
 */
export const ReanalyzeAreaEstimationDrawingResponseSchema: GenMessage<ReanalyzeAreaEstimationDrawingResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 57);

/**
 * @generated from message api_proto.v1.DeleteAreaEstimationDrawingRequest
 */
export type DeleteAreaEstimationDrawingRequest = Message<"api_proto.v1.DeleteAreaEstimationDrawingRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.DeleteAreaEstimationDrawingRequest.
 * Use `create(DeleteAreaEstimationDrawingRequestSchema)` to create a new message.
 */
export const DeleteAreaEstimationDrawingRequestSchema: GenMessage<DeleteAreaEstimationDrawingRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 58);

/**
 * 縮尺だけを変更する。
 *
 * 縮尺は px→m の換算係数にしか効かず、保存済みジオメトリ (ページ px 座標) には影響しない。
 * そのため再解析は不要で、むしろ再解析すると人が直した区分がすべて失われる。
 * 「面を分類し終えてから縮尺の誤りに気づく」動線が実際にあるため、専用の経路を用意する。
 *
 * @generated from message api_proto.v1.UpdateAreaEstimationDrawingScaleRequest
 */
export type UpdateAreaEstimationDrawingScaleRequest = Message<"api_proto.v1.UpdateAreaEstimationDrawingScaleRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string drawing_id = 1;
   */
  drawingId: string;

  /**
   * 1/100 なら 100
   *
   * @generated from field: int32 scale_denom = 2;
   */
  scaleDenom: number;
};

/**
 * Describes the message api_proto.v1.UpdateAreaEstimationDrawingScaleRequest.
 * Use `create(UpdateAreaEstimationDrawingScaleRequestSchema)` to create a new message.
 */
export const UpdateAreaEstimationDrawingScaleRequestSchema: GenMessage<UpdateAreaEstimationDrawingScaleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 59);

/**
 * @generated from message api_proto.v1.UpdateAreaEstimationDrawingScaleResponse
 */
export type UpdateAreaEstimationDrawingScaleResponse = Message<"api_proto.v1.UpdateAreaEstimationDrawingScaleResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationDrawing drawing = 1;
   */
  drawing?: AreaEstimationDrawing;
};

/**
 * Describes the message api_proto.v1.UpdateAreaEstimationDrawingScaleResponse.
 * Use `create(UpdateAreaEstimationDrawingScaleResponseSchema)` to create a new message.
 */
export const UpdateAreaEstimationDrawingScaleResponseSchema: GenMessage<UpdateAreaEstimationDrawingScaleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 60);

/**
 * 編集状態 (ポリゴン + 勾配 + バルコニー手入力) を丸ごと保存する。
 * scale は図面側の値を正とし、リクエスト内の値は無視される。
 *
 * @generated from message api_proto.v1.SaveAreaEstimationDrawingGeometryRequest
 */
export type SaveAreaEstimationDrawingGeometryRequest = Message<"api_proto.v1.SaveAreaEstimationDrawingGeometryRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string drawing_id = 1;
   */
  drawingId: string;

  /**
   * @generated from field: api_proto.v1.ElevationDrawingState state = 2;
   */
  state?: ElevationDrawingState;

  /**
   * 楽観ロック: 取得時の revision_no。latest と一致しない場合 409
   *
   * @generated from field: int32 if_match_revision_no = 3;
   */
  ifMatchRevisionNo: number;
};

/**
 * Describes the message api_proto.v1.SaveAreaEstimationDrawingGeometryRequest.
 * Use `create(SaveAreaEstimationDrawingGeometryRequestSchema)` to create a new message.
 */
export const SaveAreaEstimationDrawingGeometryRequestSchema: GenMessage<SaveAreaEstimationDrawingGeometryRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 61);

/**
 * @generated from message api_proto.v1.SaveAreaEstimationDrawingGeometryResponse
 */
export type SaveAreaEstimationDrawingGeometryResponse = Message<"api_proto.v1.SaveAreaEstimationDrawingGeometryResponse"> & {
  /**
   * @generated from field: api_proto.v1.AreaEstimationDrawingRevision revision = 1;
   */
  revision?: AreaEstimationDrawingRevision;

  /**
   * @generated from field: api_proto.v1.AreaEstimationDrawing drawing = 2;
   */
  drawing?: AreaEstimationDrawing;
};

/**
 * Describes the message api_proto.v1.SaveAreaEstimationDrawingGeometryResponse.
 * Use `create(SaveAreaEstimationDrawingGeometryResponseSchema)` to create a new message.
 */
export const SaveAreaEstimationDrawingGeometryResponseSchema: GenMessage<SaveAreaEstimationDrawingGeometryResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 62);

/**
 * 面積計算。Go が Python の AreaEstimationCalculationService/CalculateElevationArea を同期で
 * 呼び (SQS 往復は挟まない。人がマスクを直すたびに数字を返す)、共通割当をやり直した結果を
 * 現在のジオメトリとして保存する。計算の間に図面が更新されていたら aborted を返して何も書かない。
 *
 * @generated from message api_proto.v1.CalculateAreaEstimationDrawingAreaRequest
 */
export type CalculateAreaEstimationDrawingAreaRequest = Message<"api_proto.v1.CalculateAreaEstimationDrawingAreaRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string drawing_id = 1;
   */
  drawingId: string;
};

/**
 * Describes the message api_proto.v1.CalculateAreaEstimationDrawingAreaRequest.
 * Use `create(CalculateAreaEstimationDrawingAreaRequestSchema)` to create a new message.
 */
export const CalculateAreaEstimationDrawingAreaRequestSchema: GenMessage<CalculateAreaEstimationDrawingAreaRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 63);

/**
 * @generated from message api_proto.v1.CalculateAreaEstimationDrawingAreaResponse
 */
export type CalculateAreaEstimationDrawingAreaResponse = Message<"api_proto.v1.CalculateAreaEstimationDrawingAreaResponse"> & {
  /**
   * @generated from field: api_proto.v1.ElevationAreaResult result = 1;
   */
  result?: ElevationAreaResult;

  /**
   * @generated from field: api_proto.v1.AreaEstimationDrawing drawing = 2;
   */
  drawing?: AreaEstimationDrawing;

  /**
   * 共通割当をやり直した後の計算の応答 (参照実装の `/api/calculate` と同じ。形・計上・来歴だけで
   * evidence を持たない)。**正は drawing.current_state** で、サーバーはこれを解析由来の項目と
   * 重ねてから保存している。画面はこの 2 項目を使わず、保存済みの状態を読み直すこと
   * (これで編集中の面を置き換えると evidence の無い面になり、元図線由来の開口が控除されなくなる)
   *
   * @generated from field: repeated api_proto.v1.ElevationPolygon polygons = 3;
   */
  polygons: ElevationPolygon[];

  /**
   * @generated from field: repeated api_proto.v1.ElevationPolygon surface_ledger = 4;
   */
  surfaceLedger: ElevationPolygon[];
};

/**
 * Describes the message api_proto.v1.CalculateAreaEstimationDrawingAreaResponse.
 * Use `create(CalculateAreaEstimationDrawingAreaResponseSchema)` to create a new message.
 */
export const CalculateAreaEstimationDrawingAreaResponseSchema: GenMessage<CalculateAreaEstimationDrawingAreaResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 64);

/**
 * @generated from message api_proto.v1.ListAreaEstimationDrawingRevisionsRequest
 */
export type ListAreaEstimationDrawingRevisionsRequest = Message<"api_proto.v1.ListAreaEstimationDrawingRevisionsRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string drawing_id = 1;
   */
  drawingId: string;
};

/**
 * Describes the message api_proto.v1.ListAreaEstimationDrawingRevisionsRequest.
 * Use `create(ListAreaEstimationDrawingRevisionsRequestSchema)` to create a new message.
 */
export const ListAreaEstimationDrawingRevisionsRequestSchema: GenMessage<ListAreaEstimationDrawingRevisionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 65);

/**
 * @generated from message api_proto.v1.ListAreaEstimationDrawingRevisionsResponse
 */
export type ListAreaEstimationDrawingRevisionsResponse = Message<"api_proto.v1.ListAreaEstimationDrawingRevisionsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.AreaEstimationDrawingRevision revisions = 1;
   */
  revisions: AreaEstimationDrawingRevision[];
};

/**
 * Describes the message api_proto.v1.ListAreaEstimationDrawingRevisionsResponse.
 * Use `create(ListAreaEstimationDrawingRevisionsResponseSchema)` to create a new message.
 */
export const ListAreaEstimationDrawingRevisionsResponseSchema: GenMessage<ListAreaEstimationDrawingRevisionsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_area_estimation, 66);

/**
 * 方位。south/east/north/west は図面レイアウト (左上/右上/左下/右下) で決まる。
 * FULL_PAGE は計算結果の「全体」行に使う。
 *
 * @generated from enum api_proto.v1.ElevationDirection
 */
export enum ElevationDirection {
  /**
   * @generated from enum value: ELEVATION_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 南
   *
   * @generated from enum value: ELEVATION_DIRECTION_SOUTH = 1;
   */
  SOUTH = 1,

  /**
   * 東
   *
   * @generated from enum value: ELEVATION_DIRECTION_EAST = 2;
   */
  EAST = 2,

  /**
   * 北
   *
   * @generated from enum value: ELEVATION_DIRECTION_NORTH = 3;
   */
  NORTH = 3,

  /**
   * 西
   *
   * @generated from enum value: ELEVATION_DIRECTION_WEST = 4;
   */
  WEST = 4,

  /**
   * 全体 (方位に割り当てない集計行)
   *
   * @generated from enum value: ELEVATION_DIRECTION_FULL_PAGE = 5;
   */
  FULL_PAGE = 5,
}

/**
 * Describes the enum api_proto.v1.ElevationDirection.
 */
export const ElevationDirectionSchema: GenEnum<ElevationDirection> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_area_estimation, 0);

/**
 * ポリゴンの部位 (参照実装の part と 1:1)。
 *
 * @generated from enum api_proto.v1.ElevationPart
 */
export enum ElevationPart {
  /**
   * @generated from enum value: ELEVATION_PART_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 外壁 (外周から開口部を引いたネットで計上)
   *
   * @generated from enum value: ELEVATION_PART_EXTERIOR_WALL = 1;
   */
  EXTERIOR_WALL = 1,

  /**
   * バルコニー垂直面 (外壁とは別計上)
   *
   * @generated from enum value: ELEVATION_PART_BALCONY = 2;
   */
  BALCONY = 2,

  /**
   * 屋根 (階未確定)
   *
   * @generated from enum value: ELEVATION_PART_ROOF = 3;
   */
  ROOF = 3,

  /**
   * 屋根(1階) = 下屋・玄関・ポーチ屋根
   *
   * @generated from enum value: ELEVATION_PART_ROOF_1F = 4;
   */
  ROOF_1F = 4,

  /**
   * 屋根(2階) = 主屋根
   *
   * @generated from enum value: ELEVATION_PART_ROOF_2F = 5;
   */
  ROOF_2F = 5,

  /**
   * 外周長の計測線 (面積計算しない)
   *
   * @generated from enum value: ELEVATION_PART_PERIMETER = 6;
   */
  PERIMETER = 6,

  /**
   * 基礎 (参照実装 v4 の 6 色分類の赤紫)。外壁・バルコニーとは別に集計する。
   * 共通割当では最優先 (他の部位と重なった領域は基礎に属する)
   *
   * @generated from enum value: ELEVATION_PART_FOUNDATION = 7;
   */
  FOUNDATION = 7,

  /**
   * 開口部 (窓・ドア・シャッター・車庫開口。参照実装 d6e66f2 の独立検出)。上下左右に平行な 4 点の
   * 長方形 1 つで持ち、同じ立面図の外壁・屋根・バルコニーから控除する (基礎は控除しない)。
   * 面積・周長 (コーキング) の正本で、それ自体は材料として計上しない
   *
   * @generated from enum value: ELEVATION_PART_OPENING = 8;
   */
  OPENING = 8,
}

/**
 * Describes the enum api_proto.v1.ElevationPart.
 */
export const ElevationPartSchema: GenEnum<ElevationPart> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_area_estimation, 1);

/**
 * ポリゴンの確認状態 (ポリゴン仕様 §4)。
 * データモデルとしては保持しているが、確認状態による計算拒否ゲートは撤廃済み (PdM 判断:
 * 確認作業自体を不要にする)。EXCLUDED 以外は review_status に関わらず計算対象になる。
 *
 * @generated from enum api_proto.v1.ElevationReviewStatus
 */
export enum ElevationReviewStatus {
  /**
   * @generated from enum value: ELEVATION_REVIEW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 線抽出だけで作った候補
   *
   * @generated from enum value: ELEVATION_REVIEW_STATUS_CANDIDATE = 1;
   */
  CANDIDATE = 1,

  /**
   * 根拠線・部位検査を通過
   *
   * @generated from enum value: ELEVATION_REVIEW_STATUS_AUTO_CONFIRMED = 2;
   */
  AUTO_CONFIRMED = 2,

  /**
   * 根拠不足 (表示上「要確認」だが計算対象には含む)
   *
   * @generated from enum value: ELEVATION_REVIEW_STATUS_REVIEW_REQUIRED = 3;
   */
  REVIEW_REQUIRED = 3,

  /**
   * 利用者が確認して確定した
   *
   * @generated from enum value: ELEVATION_REVIEW_STATUS_MANUAL_CONFIRMED = 4;
   */
  MANUAL_CONFIRMED = 4,

  /**
   * 積算対象外。参照実装同様、excluded なポリゴンは形状検査・方位検査・面積集計のいずれからも除く
   *
   * @generated from enum value: ELEVATION_REVIEW_STATUS_EXCLUDED = 5;
   */
  EXCLUDED = 5,
}

/**
 * Describes the enum api_proto.v1.ElevationReviewStatus.
 */
export const ElevationReviewStatusSchema: GenEnum<ElevationReviewStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_area_estimation, 2);

/**
 * リングの役割。
 *
 * @generated from enum api_proto.v1.ElevationRingRole
 */
export enum ElevationRingRole {
  /**
   * @generated from enum value: ELEVATION_RING_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 外周
   *
   * @generated from enum value: ELEVATION_RING_ROLE_OUTER = 1;
   */
  OUTER = 1,

  /**
   * 内周 (開口部などの控除)
   *
   * @generated from enum value: ELEVATION_RING_ROLE_INNER = 2;
   */
  INNER = 2,
}

/**
 * Describes the enum api_proto.v1.ElevationRingRole.
 */
export const ElevationRingRoleSchema: GenEnum<ElevationRingRole> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_area_estimation, 3);

/**
 * 縮尺の使用可否。
 * RECALIBRATION_REQUIRED はサーバー側の面積計算 (Python の calculation.calculate) のゲートになる:
 * ElevationDrawingState.scale_calibration が無いまま計算を要求すると InvalidArgument で拒否する。
 *
 * @generated from enum api_proto.v1.ElevationScaleStatus
 */
export enum ElevationScaleStatus {
  /**
   * @generated from enum value: ELEVATION_SCALE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 使用可
   *
   * @generated from enum value: ELEVATION_SCALE_STATUS_USABLE = 1;
   */
  USABLE = 1,

  /**
   * 解析前の歪み補正を適用した図面。PDF の縮尺 (1/N) は補正前の寸法に対するもので使えないため、
   * ElevationDrawingState.scale_calibration (辺の実寸) が無いと面積計算を拒否する
   *
   * @generated from enum value: ELEVATION_SCALE_STATUS_RECALIBRATION_REQUIRED = 2;
   */
  RECALIBRATION_REQUIRED = 2,
}

/**
 * Describes the enum api_proto.v1.ElevationScaleStatus.
 */
export const ElevationScaleStatusSchema: GenEnum<ElevationScaleStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_area_estimation, 4);

/**
 * 解析ジョブ (AI 意味判定 + 構造線スナップ) の進行状態。
 *
 * @generated from enum api_proto.v1.ElevationAnalysisStatus
 */
export enum ElevationAnalysisStatus {
  /**
   * @generated from enum value: ELEVATION_ANALYSIS_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * SQS へ enqueue 済み / Python 未着手
   *
   * @generated from enum value: ELEVATION_ANALYSIS_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Python 処理中
   *
   * @generated from enum value: ELEVATION_ANALYSIS_STATUS_PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * 完了
   *
   * @generated from enum value: ELEVATION_ANALYSIS_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * 失敗
   *
   * @generated from enum value: ELEVATION_ANALYSIS_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum api_proto.v1.ElevationAnalysisStatus.
 */
export const ElevationAnalysisStatusSchema: GenEnum<ElevationAnalysisStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_area_estimation, 5);

/**
 * Revision の operation type。
 *
 * @generated from enum api_proto.v1.ElevationOperationType
 */
export enum ElevationOperationType {
  /**
   * @generated from enum value: ELEVATION_OPERATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 解析直後のスナップショット
   *
   * @generated from enum value: ELEVATION_OPERATION_TYPE_ANALYZE = 1;
   */
  ANALYZE = 1,

  /**
   * 人が編集して保存
   *
   * @generated from enum value: ELEVATION_OPERATION_TYPE_SAVE = 2;
   */
  SAVE = 2,

  /**
   * 面積計算実行
   *
   * @generated from enum value: ELEVATION_OPERATION_TYPE_CALCULATE = 3;
   */
  CALCULATE = 3,
}

/**
 * Describes the enum api_proto.v1.ElevationOperationType.
 */
export const ElevationOperationTypeSchema: GenEnum<ElevationOperationType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_area_estimation, 6);

